import { render, staticRenderFns } from "./ShareFileModal.vue?vue&type=template&id=6fa33d1f&scoped=true&"
import script from "./ShareFileModal.vue?vue&type=script&lang=js&"
export * from "./ShareFileModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareFileModal.vue?vue&type=style&index=0&id=6fa33d1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa33d1f",
  null
  
)

export default component.exports